import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Field } from "./InvoiceForm";

const today = () => new Date().toISOString().slice(0, 10);
const blank = () => ({ date: today(), direction: "Sent", channel: "Email", summary: "" });
const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
const TONE = { Sent: "bg-forest text-white", Received: "bg-amber-100 text-amber-900", Note: "bg-stone text-charcoal" };

export function ClaimLog({ entries, onChange }) {
  const [draft, setDraft] = useState(blank);
  const set = (k) => (v) => setDraft((d) => ({ ...d, [k]: v }));
  const sorted = entries.map((e, i) => ({ ...e, i })).sort((a, b) => b.date.localeCompare(a.date) || b.i - a.i);
  const add = () => {
    if (!draft.summary.trim()) return;
    onChange([...entries, { ...draft, summary: draft.summary.trim() }]);
    setDraft(blank());
  };
  return (
    <fieldset className="mb-6" data-testid="claim-log">
      <legend className="mb-3 text-sm font-semibold text-forest">Correspondence log ({entries.length}, internal, not printed)</legend>
      {sorted.length > 0 && (
        <ol className="mb-4 space-y-2 border-l-2 border-stone pl-4">
          {sorted.map((e) => (
            <li key={e.i} className="relative bg-white/60 p-3 text-sm" data-testid={`claim-log-entry-${e.i}`}>
              <div className="mb-1 flex flex-wrap items-center gap-2 text-xs">
                <span className="font-semibold text-charcoal">{fmt(e.date)}</span>
                <span className={`px-1.5 py-0.5 ${TONE[e.direction]}`}>{e.direction}</span>
                <span className="text-charcoal/70">{e.channel}</span>
                <button type="button" onClick={() => onChange(entries.filter((_, j) => j !== e.i))} aria-label="Delete log entry"
                  className="ml-auto p-1 text-red-800 transition-colors hover:bg-red-50" data-testid={`claim-log-entry-${e.i}-delete`}><Trash2 size={14} /></button>
              </div>
              <p className="whitespace-pre-line text-charcoal/85">{e.summary}</p>
            </li>
          ))}
        </ol>
      )}
      <div className="grid gap-3 sm:grid-cols-3">
        <Field k="date" label="Date" type="date" value={draft.date} onChange={set("date")} prefix="claim-log" />
        <Field k="direction" label="Type" type="select" options={["Sent", "Received", "Note"]} value={draft.direction} onChange={set("direction")} prefix="claim-log" />
        <Field k="channel" label="By" type="select" options={["Email", "Letter", "Phone", "WhatsApp", "Other"]} value={draft.channel} onChange={set("channel")} prefix="claim-log" />
        <div className="sm:col-span-3">
          <Field k="summary" label="What was said (paste the email or summarise)" type="textarea" value={draft.summary} onChange={set("summary")} prefix="claim-log" />
        </div>
      </div>
      <button type="button" onClick={add} disabled={!draft.summary.trim()} className="btn mt-3 inline-flex items-center gap-2 !py-2.5 text-sm disabled:opacity-50" data-testid="claim-log-add">
        <Plus size={16} /> Add to log
      </button>
      {entries.length > 0 && <p className="mt-2 text-xs text-charcoal/70">Save the claim to keep log changes.</p>}
    </fieldset>
  );
}
